/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Clear_Descriptions_MenuInputs */

const en_markers_clear_descriptions_menu = /** @type {(inputs: Markers_Clear_Descriptions_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Marker Descriptions`)
};

const fr_markers_clear_descriptions_menu = /** @type {(inputs: Markers_Clear_Descriptions_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer les descriptions de marqueurs`)
};

const de_markers_clear_descriptions_menu = /** @type {(inputs: Markers_Clear_Descriptions_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibungen der Markierungen`)
};

const it_markers_clear_descriptions_menu = /** @type {(inputs: Markers_Clear_Descriptions_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizioni chiare dei marcatori`)
};

const ru_markers_clear_descriptions_menu = /** @type {(inputs: Markers_Clear_Descriptions_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Описать маркеры`)
};

const es_markers_clear_descriptions_menu = /** @type {(inputs: Markers_Clear_Descriptions_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripciones claras de marcadores`)
};

const zh_cn2_markers_clear_descriptions_menu = /** @type {(inputs: Markers_Clear_Descriptions_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清晰的标记描述`)
};

const ja_markers_clear_descriptions_menu = /** @type {(inputs: Markers_Clear_Descriptions_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明確なマーカーの説明`)
};

const hi_markers_clear_descriptions_menu = /** @type {(inputs: Markers_Clear_Descriptions_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मार्कर विवरण स्पष्ट करें`)
};

const pt_pt2_markers_clear_descriptions_menu = /** @type {(inputs: Markers_Clear_Descriptions_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrições claras dos marcadores`)
};

/**
* | output |
* | --- |
* | "Clear Marker Descriptions" |
*
* @param {Markers_Clear_Descriptions_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_clear_descriptions_menu = /** @type {((inputs?: Markers_Clear_Descriptions_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Clear_Descriptions_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_clear_descriptions_menu(inputs)
	if (locale === "de") return de_markers_clear_descriptions_menu(inputs)
	if (locale === "it") return it_markers_clear_descriptions_menu(inputs)
	if (locale === "ru") return ru_markers_clear_descriptions_menu(inputs)
	if (locale === "es") return es_markers_clear_descriptions_menu(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_clear_descriptions_menu(inputs)
	if (locale === "ja") return ja_markers_clear_descriptions_menu(inputs)
	if (locale === "hi") return hi_markers_clear_descriptions_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_clear_descriptions_menu(inputs)
	return en_markers_clear_descriptions_menu(inputs)
});